var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C5.58869 0 1.78673 2.38779 0.0402296 5.83353C-0.0134099 5.93794 -0.0134099 6.06009 0.0402296 6.16648C1.78673 9.6122 5.58871 12 10 12C14.4113 12 18.2133 9.61222 19.9598 6.16648C20.0134 6.06206 20.0134 5.93991 19.9598 5.83353C18.2133 2.38779 14.4113 0 10 0ZM10 10.1402C7.50898 10.1402 5.49214 8.28632 5.49214 6.00099C5.49214 3.71368 7.51113 1.86176 10 1.86176C12.491 1.86176 14.5079 3.71565 14.5079 6.00099C14.5079 8.28632 12.4889 10.1402 10 10.1402Z",
    fill: "#B6CDE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 8.64899C11.5937 8.64899 12.8857 7.46263 12.8857 5.99918C12.8857 4.53573 11.5937 3.34937 9.99994 3.34937C8.40615 3.34937 7.11414 4.53573 7.11414 5.99918C7.11414 7.46263 8.40615 8.64899 9.99994 8.64899Z",
    fill: "#B6CDE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7ed9332bacadb0820752d02ce14b906b.svg";
export { ForwardRef as ReactComponent };